import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function FolderIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="16"
        viewBox="0 0 18 16"
      >
        <path
          fillRule="evenodd"
          d="M11.4558,1.36754 L12,3 L16,3 C17.1046,3 18,3.89543 18,5 L18,14 C18,15.1046 17.1046,16 16,16 L2,16 C0.895431,16 0,15.1046 0,14 L0,2 C0,0.895431 0.895431,0 2,0 L9.55848,0 C10.4193,0 11.1836,0.55086 11.4558,1.36754 Z"
        />
      </svg>
    </Icon>
  );
}
